module.exports = __webpack_public_path__ + "img/365.b97bd0c0.svg";